import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { SWITCH_HEADERS, SWITCH_MAC_ADDRESS_ARRAY } from '../../../lib/constants';
import SpinnerCircles from '../../Spinner/SpinerCircles';
import { useDispatch, useSelector } from 'react-redux';
import * as BoxesActions from '../../../actions/EpikBoxes';
import TooltipIcon from './TooltipIcon/TooltipIcon';
import fetchLogo from '../../../Res/Icon/Fetch-Results.svg'

const valueChecker = (heading, value) => {
  if (value === 'Data could not be fetched') {
    return <label style={{ color: '#FF0000' }}>Data Not compatible with v2 firmware</label>;
  } else {
    if (SWITCH_HEADERS.includes(heading)) {
      if (value === 'true') {
        return <label style={{ color: '#3A5AA9' }}>{value}</label>;
      } else if (value === 'false') {
        return <label style={{ color: '#FF0000' }}>{value}</label>;
      } else {
        const dashSplit = value.split(' - ');
        const epiMacArray = [];
        dashSplit.forEach(string => {
          if (string.includes(',')) {
            const [ipInitial, ipAddress] = string.split(',');
            const exisits = SWITCH_MAC_ADDRESS_ARRAY.includes(ipAddress.split('.').pop());
            exisits
              ? epiMacArray.push(
                  `<label><label style="color:#000000" }}>${ipInitial +
                    ','}</label><label style="color:#3A5AA9" }}>${ipAddress}</label></label>`,
                )
              : epiMacArray.push(
                  `<label><label style="color:#000000" }}>${ipInitial +
                    ','}</label><label style="color:#FF0000" }}>${ipAddress}</label></label>`,
                );
          } else {
            const dotExisit = string.includes('.');
            if (dotExisit) {
              const exisits = SWITCH_MAC_ADDRESS_ARRAY.includes(string.split('.').pop());
              exisits
                ? epiMacArray.push(`<label style="color: #3A5AA9" }}>${string}</label>`)
                : epiMacArray.push(`<label style="color:#FF0000" }}>${string}</label>`);
            } else {
              epiMacArray.push(`<label style="color:#000000" }}>${string}</label>`);
            }
          }
        });
        const joinArray = epiMacArray.join(' - ');
        return <label dangerouslySetInnerHTML={{ __html: joinArray }} />;
      }
    } else
      return (
        <label dangerouslySetInnerHTML={{ __html: value }} style={{ color: '#3A5AA9' }}></label>
      );
  }
};

const token = localStorage.getItem('jwtToken') || null;

const SwitchInfo = ({ loadingStatus, onReloadStatus, boxDetails }) => {
  const systemStatus = useSelector(state => state.AppState.boxDetails.systemStatus);
  return (
    <div className="sysInfoView ">
      <Row className="w-100">
        {!boxDetails.myEpik && (
          <Col sm={12} md={12} lg={12} xs={12} className="p-0 border-left">
            <h5 className="card-header">Epik Edge Status</h5>
            {!loadingStatus && (
              <div className="right-card-body card-body">
                {systemStatus?.map((systemstatus, index) => (
                  <pre key={index}>
                    <label
                      id={`test-${systemstatus?.placeHolderText?.replace(' ', '-')?.toLowerCase()}`}
                    >
                      {systemstatus?.placeHolderText}:&nbsp;
                    </label>
                    {valueChecker(systemstatus?.placeHolderText, systemstatus?.value)}
                  </pre>
                ))}
              </div>
            )}
            
            <div onClick={onReloadStatus} id="test-vswitch-info-refresh-tab">
              {loadingStatus ? (
                <div className="reload hide-bg">
                  <SpinnerCircles red />
                </div>
              ) : (
              
                    <div class="col d-flex justify-content-end">
                <TooltipIcon
                   tipId="add-time-icon"
                   imgSrc={fetchLogo}
                   displayData="Fetch Vswitch Info"
                   placement="top"
                 />
                 </div>
              
              
              )}
            </div>
          </Col>

        )}
      </Row>
    </div>
  );
};

export default SwitchInfo;
